import React from "react";
import "./Museum.scss"

class Museum extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
            links:[
                {
                    url: "https://brighterworld.mcmaster.ca/articles/engineering-students-create-device-for-farmers-and-museums/",
                    image: require("assets/img/engineerstudents_museumofart-14-2-1024x607.jpg"),
                    text: "Engineering students create device for farmers — and museums",
                    msg: "The engineering students of EltroTech originally created the Agriboost device to monitor environmental conditions that affect crops. But they're testing their invention in the tightly controlled environment of the McMaster Museum of Art..."
                },
                {
                    url: "https://www.eng.mcmaster.ca/news/software-and-mechatronics-students-create-device-farmers-and-museum-world",
                    image: require("assets/img/engineerstudents_museumofart-12.jpg"),
                    text: "Software and Mechatronics students create device for farmers and the museum world", 
                    msg:"A device originally conceived as a tool to monitor environmental conditions has an unexpected purpose. A team of Software and Mechatronics Engineering students have collaborated on a project to help farmers that may also have applications in the museum world..."
                }
            ]
        };
        
    }

    openLink(link){
        var win = window.open(link, '_blank');
        win.focus();
    }


    link(data){
        return(
                <div className="cardParent">
                    <img className="img" src={data.image} alt="Sunset in the mountains"/>
                    <div className="box">
                        {/* <a class="box-text secretLink" href={data.url}>{data.text}</a> */}
                        <div className="box-text" href={data.url}><i className="tim-icons icon-link-72" /> {data.text}</div>
                        {/* <div class="box-text" onClick={this.openLink.bind(this, data.url)} ><i className="tim-icons icon-link-72" /> {data.text}</div> */}
                        {/* <div class="box-text" href={data.url}>{data.text}</div> */}
                        <span>{data.msg}</span>    

                        <a className="link" href={data.url} target="_blank" rel="noopener noreferrer" >Read More</a>
                        {/* <a class="link" href={data.url} target="_blank" rel="noopener noreferrer" >Read More</a> */}
                    </div>
                </div>
        );
    }


	render() {
		return (
			<div className="museumSection section" ref={this.props.refs}>
                <h1 className="center">Art Museum Collaboration</h1>

                <div className="split">
                    <div className="left">
                        {/* <h3>What is AgriBoost?</h3> */}
                        {/* <p>Agricultural farming is the stepping stone for life as we know it today. The industry has changed drastically since the first farms, with advancements in technology, crop cycling, and new concepts. Precision Agriculture (PA) is one of these concepts, which is based on observing, measuring and responding to inter and intra-field variability in crops; with the goal of responding to varying conditions to maximize yield.</p> */}
                        <p>Monitoring and recording of environmental conditions are not limited to farms exclusively. Museums also require tightly regulated environmental conditions in order to preserve their art work. </p>
                        <p>Traditionally, this monitoring is done on a hygrothermograph, an analog instrument that measures and records temperature and relative humidity on a paper graph. </p>
                        <p>In collaboration with McMaster Art Museum, Agriboost adapted to digitize this experience. We created and deployed a version of the Agriboost system to collect, monitor, and report the environmental conditions within the art gallery in real time.</p>
                    </div>
                    <div className="right end">
                        <img
                            src={require("assets/img/EngineerStudents_MuseumofArt-8.jpg")}
                        />
                    </div>
                </div>

                <div className="museumCardsWrapper">
                    {this.link(this.state.links[0])}
                    {this.link(this.state.links[1])}
                </div>

			</div>
		);
	}
}
export default Museum;

